export default __webpack_public_path__ + "static/media/all_games_banner.cc0ea5ab.png";